import * as z from 'zod';
import { ExpenseCategory, PaymentMethod } from '@/generated/prisma/enums';

const ExpenseItemSchema = z.object({
  description: z.string().min(1, { message: 'Description is required!' }),
  qty: z.number().positive({ message: 'Quantity must be greater than 0' }),
  unit: z.string(),
  price: z.number().positive({ message: 'Price must be greater than 0' }),
  tax: z.number().min(0).max(100, { message: 'Tax must be between 0 and 100' }),
  taxAmount: z.number().min(0).optional(),
  total: z.number().positive({ message: 'Total must be greater than 0' }),
});

export const CreateExpenseSchema = z
  .object({
    id: z.string().optional(),
    // Simple mode: description and amount (optional if using items)
    description: z.string().optional(),
    amount: z.number().min(0).optional(),
    taxAmount: z.number().min(0).optional(),
    // Itemized mode: items array
    items: ExpenseItemSchema.array().optional(),
    date: z.date({ message: 'Date is required!' }),
    category: z.nativeEnum(ExpenseCategory).optional(),
    vendor: z.string().optional(),
    invoiceNumber: z.string().optional(),
    paymentMethod: z.nativeEnum(PaymentMethod).optional(),
    receiptUrl: z.string().url().optional().or(z.literal('')),
    notes: z.string().optional(),
  })
  .refine(
    (data) => {
      // Either items array OR (description and amount) must be provided
      const hasItems = data.items && data.items.length > 0;
      const hasSimpleFields =
        data.description &&
        data.description.trim() !== '' &&
        data.amount &&
        data.amount > 0;
      return hasItems || hasSimpleFields;
    },
    {
      message: 'Either add items or provide description and amount',
      path: ['description'],
    }
  );
